/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Updated_SuccessInputs */

const en_users_updated_success = /** @type {(inputs: Users_Updated_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User updated successfully.`)
};

const pt_br2_users_updated_success = /** @type {(inputs: Users_Updated_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usuário atualizado com sucesso.`)
};

/**
* | output |
* | --- |
* | "User updated successfully." |
*
* @param {Users_Updated_SuccessInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_updated_success = /** @type {((inputs?: Users_Updated_SuccessInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Updated_SuccessInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_updated_success(inputs)
	return pt_br2_users_updated_success(inputs)
});